export default "__VITE_ASSET__Wk0OYKId__"